// extracted by mini-css-extract-plugin
export default {"aiTextDecoration":"RequiredLabelTooltip_aiTextDecoration__uEgdS"};